<template>
  <div
    class="page-layout"
    :style="{ background: bgcolor }"
    :class="{ 'show-crystal-texture': showCrystalTexture }"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "PageLayout",
  props: {
    centered: {
      type: Boolean,
      default: false,
    },
    bgcolor: {
      type: String,
      default: "#000",
    },
    showCrystalTexture: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    // 页面进入时滚动到顶部
    this.scrollToTop();
  },
  methods: {
    // 滚动到顶部
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: "instant",
      });
    },
    // 向上滚动50vh
    scrollUp() {
      window.scrollBy({ top: -window.innerHeight * 0.5, behavior: 'smooth' });
    },
    // 向下滚动50vh
    scrollDown() {
      window.scrollBy({ top: window.innerHeight * 0.5, behavior: 'smooth' });
    }
  },
};
</script>

<style scoped>
.page-layout {
  min-height: 100vh;
  color: #fff;
  position: relative;
}


</style>
